import { render } from "./Demographic.vue?vue&type=template&id=12da7c83&scoped=true"
import script from "./Demographic.vue?vue&type=script&lang=js"
export * from "./Demographic.vue?vue&type=script&lang=js"

import "./Demographic.vue?vue&type=style&index=0&id=12da7c83&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12da7c83"]])

export default __exports__